<template>
  <div class="main-slider-container">
    <call-to-action class="call-to-action-banner"></call-to-action>

    <div class="slider-wrapper">
      <carousel :autoplay="true"
                :autoplayTimeout="10000"
                :autoplayHoverPause="true"
                :perPage="1"
                :paginationEnabled="false"
                :navigationEnabled="true"
                :navigationClickTargetSize="20"
                :loop="true">
        <slide v-for="(slide, index) in slides" :key="index">
          <v-img :src="slide.image"
                 :alt="slide.alt"
                 class="slider-image"
                 :gradient="isMobile ? 'to top, rgba(0,0,0,0.6), rgba(0,0,0,0.4)' : 'to top, rgba(0,0,0,0.4), rgba(0,0,0,0.2)'">
            <div class="slider-content-wrapper">
              <div class="slider-overlay-content">
                <h1 class="slider-title earthwerk-font">Discover Ol Pejeta</h1>
                <p class="slider-subtitle">Experience Kenya's wildlife wonderland</p>
              </div>
            </div>
          </v-img>
        </slide>

        <template slot="prevButton">
          <button class="v-carousel-control v-carousel-control--prev" :class="{ 'mobile-nav': isMobile }">
            <v-icon dark>chevron_left</v-icon>
          </button>
        </template>

        <template slot="nextButton">
          <button class="v-carousel-control v-carousel-control--next" :class="{ 'mobile-nav': isMobile }">
            <v-icon dark>chevron_right</v-icon>
          </button>
        </template>
      </carousel>

      <!-- Moved search component outside carousel 
      <div class="search-position" :class="{ 'mobile-search': isMobile }">
        <search id="search-component" class="search-box"></search>
      </div> -->
    </div>
  </div>
</template>

<script>
  import Search from './Search.vue';
  import CallToAction from './CallToAction.vue';

  export default {
    name: 'PublicMainSlider',
    components: {
      CallToAction,
      Search,
    },
    data() {
      return {
        slides: [
          { image: require('@/assets/Public/banners/elephants.jpg'), alt: 'Elephants in the wild' },
          { image: require('@/assets/Public/banners/lioness.jpg'), alt: 'Lioness on the hunt' },
          { image: require('@/assets/Public/banners/secretary.jpg'), alt: 'Secretary bird' },
          { image: require('@/assets/Public/banners/zebra.jpg'), alt: 'Zebra herd' },
        ],
        windowWidth: typeof window !== 'undefined' ? window.innerWidth : 1200
      };
    },
    computed: {
      isMobile() {
        return this.windowWidth < 768
      },
      isTablet() {
        return this.windowWidth >= 768 && this.windowWidth < 1024
      }
    },
    mounted() {
      this.handleResize()
      window.addEventListener('resize', this.handleResize)
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.handleResize)
    },
    methods: {
      handleResize() {
        this.windowWidth = window.innerWidth
      }
    }
  };
</script>

<style scoped>
  @font-face {
    font-family: 'Earthwerk';
    src: url('PizzaDude.dk-Earthwerk.otf') format('opentype');
    font-weight: normal;
    font-style: normal;
  }

.main-slider-container {
  position: relative;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 16px 20px 0;
  overflow: hidden;
}

.call-to-action-banner {
  position: static; 
  margin-bottom: 12px;
}

.slider-wrapper {
  position: relative;
  width: 100%;
  margin-top: 0; /* was 60px */
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}


.slider-image {
  width: 100%;
  height: 420px;   
  min-height: 0;
  object-fit: cover;
}

  .slider-content-wrapper {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start; 
  }

.slider-overlay-content {
  padding: 24px;   
  margin-top: 0;   
  max-width: 700px;
}

.earthwerk-font,
.slider-title {
  font-size: 2.2rem; 
  margin-bottom: 6px;
}


  .slider-title {
    font-size: 3.5rem;
    font-weight: bold;
    color: white;
  }

.slider-subtitle {
  font-size: 1rem;   
  margin-bottom: 0;
}

  .search-position {
    position: absolute;
    bottom: 60px; 
    width: 100%;
    padding: 0 40px;
    z-index: 5; 
  }

  .search-box {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
  }

  /* Carousel navigation buttons */
  .v-carousel-control {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 50px;
    height: 50px;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 5;
    transition: all 0.3s ease;
    border: none;
    outline: none;
  }

    .v-carousel-control:hover {
      background: rgba(0, 0, 0, 0.5);
    }

  .v-carousel-control--prev {
    left: 20px;
  }

  .v-carousel-control--next {
    right: 20px;
  }

  /* ======================= RESPONSIVE STYLES ======================= */

  /* Large Desktop (1200px - 1440px) */
  @media (max-width: 1440px) {
    .slider-overlay-content {
      max-width: 70%;
    }

    .slider-image {
      height: calc(85vh - 60px);
    }
  }

  /* Desktop (1024px - 1200px) */
  @media (max-width: 1200px) {
    .slider-overlay-content {
      max-width: 65%;
      padding: 35px;
    }

    .slider-title {
      font-size: 3rem;
    }

    .slider-subtitle {
      font-size: 1.3rem;
    }
  }

  /* Tablet (768px - 1024px) */
  @media (max-width: 1024px) {
    .slider-wrapper {
      margin-top: 55px;
    }

    .slider-image {
      height: calc(80vh - 55px);
      min-height: 500px;
    }

    .slider-overlay-content {
      padding: 30px;
      max-width: 75%;
      margin-top: 30px;
    }

    .slider-title {
      font-size: 2.8rem;
    }

    .slider-subtitle {
      font-size: 1.2rem;
      margin-bottom: 1.5rem;
    }

    .search-position {
      padding: 0 30px;
      bottom: 50px;
    }

    .v-carousel-control {
      width: 45px;
      height: 45px;
    }
  }

  /* Mobile Landscape (600px - 768px) */
  @media (max-width: 768px) {
    .slider-wrapper {
      margin-top: 50px;
    }

    .slider-image {
      height: calc(70vh - 50px);
      min-height: 450px;
    }

    .slider-overlay-content {
      padding: 25px;
      max-width: 85%;
      margin-top: 25px;
    }

    .slider-title {
      font-size: 2.2rem;
    }

    .slider-subtitle {
      font-size: 1rem;
      margin-bottom: 1.2rem;
    }

    .search-position {
      padding: 0 20px;
      bottom: 40px;
    }

    .search-position.mobile-search {
      bottom: 30px;
    }

    .v-carousel-control {
      width: 38px;
      height: 38px;
    }

    .v-carousel-control.mobile-nav {
      width: 32px;
      height: 32px;
      background: rgba(0, 0, 0, 0.4);
    }

    .v-carousel-control--prev.mobile-nav {
      left: 12px;
    }

    .v-carousel-control--next.mobile-nav {
      right: 12px;
    }
  }

  /* Mobile Portrait (480px - 600px) */
  @media (max-width: 600px) {
    .slider-wrapper {
      margin-top: 45px;
    }

    .slider-image {
      height: calc(65vh - 45px);
      min-height: 400px;
    }

    .slider-overlay-content {
      padding: 20px;
      max-width: 90%;
      margin-top: 20px;
    }

    .slider-title {
      font-size: 1.8rem;
      margin-bottom: 0.5rem;
    }

    .slider-subtitle {
      font-size: 0.9rem;
      margin-bottom: 1rem;
    }

    .search-position {
      padding: 0 15px;
      bottom: 30px;
    }

    .v-carousel-control {
      width: 34px;
      height: 34px;
    }

    .v-carousel-control .v-icon {
      font-size: 20px;
    }
  }

  /* Small Mobile (320px - 480px) */
  @media (max-width: 480px) {
    .slider-wrapper {
      margin-top: 40px;
    }

    .slider-image {
      height: calc(60vh - 40px);
      min-height: 350px;
    }

    .slider-overlay-content {
      padding: 15px;
      max-width: 95%;
      margin-top: 15px;
    }

    .slider-title {
      font-size: 1.4rem;
      margin-bottom: 0.3rem;
    }

    .slider-subtitle {
      font-size: 0.75rem;
      margin-bottom: 0.8rem;
    }

    .search-position {
      padding: 0 12px;
      bottom: 25px;
    }

    .v-carousel-control {
      width: 30px;
      height: 30px;
    }

    .v-carousel-control .v-icon {
      font-size: 18px;
    }

    .v-carousel-control--prev {
      left: 10px;
    }

    .v-carousel-control--next {
      right: 10px;
    }
  }

  /* Extra Small Mobile (up to 360px) */
  @media (max-width: 360px) {
    .slider-image {
      height: calc(55vh - 40px);
      min-height: 300px;
    }

    .slider-title {
      font-size: 1.2rem;
    }

    .slider-subtitle {
      font-size: 0.7rem;
    }

    .search-position {
      bottom: 20px;
    }

    .v-carousel-control {
      width: 28px;
      height: 28px;
    }

    .v-carousel-control .v-icon {
      font-size: 16px;
    }
  }

  /* Hide navigation arrows on very small devices (optional - touch swipe is enough) */
  @media (max-width: 480px) {
    /* Uncomment below if you want to hide arrows on mobile */
    /* .v-carousel-control {
      display: none;
    } */
  }

  /* Adjust carousel dots/indicators if pagination enabled */
  .VueCarousel-dot-container {
    bottom: 20px !important;
  }

  @media (max-width: 768px) {
    .VueCarousel-dot-container {
      bottom: 10px !important;
    }
    
    .VueCarousel-dot {
      padding: 4px !important;
    }
    
    .VueCarousel-dot > button {
      width: 8px !important;
      height: 8px !important;
    }
  }

  @media (max-width: 480px) {
    .VueCarousel-dot {
      padding: 3px !important;
    }
    
    .VueCarousel-dot > button {
      width: 6px !important;
      height: 6px !important;
    }
  }
</style>